<template>
  <div class="leaderboard-head">
    <div
      :inner-html.prop="titleHTML"
      class="final-title"
    />
    <div
      v-if="isLoadLastDataLeaderboard"
      class="final-stat"
    >
      {{ $t('Calculating your ranking…') }} <aha-spinner />
    </div>
    <div
      v-if="isAnsweredAtLeastOne && !isLoadLastDataLeaderboard"
      v-html="answerStatText"
      class="final-stat"
    />
    <div
      v-if="!isAnsweredAtLeastOne && !isLoadLastDataLeaderboard"
      v-html="noQuizAnsweredText"
      class="final-rank"
    />
    <div
      v-if="isAnsweredAtLeastOne && !isLoadLastDataLeaderboard"
      v-html="$t('final_ranking', {
        ranking: ranking
      })"
      class="final-rank"
    />
    <div
      v-if="isShowCTA"
      class="section-cta"
    >
      <aha-antd-button
        variant="secondary"
        size="lg"
        class="section-cta__button"
        @click="viewMyAnswers"
      >
        {{ $t('view_answers') }}
      </aha-antd-button>
    </div>
  </div>
</template>

<script>
import util from '@/util'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    currentQuiz: {
      type: Number,
      default: 1,
    },
    presentationID: {
      type: Number,
      default: null,
    },
    isShowAudiencePacingNextSlide: {
      type: Boolean,
      default: false,
    },
    lastSlide: {
      type: Boolean,
      default: false,
    },
    isFinalLeaderboard: {
      type: Boolean,
      default: false,
    },
    titleHTML: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'individual',
      validator: (value) => ['individual', 'team'].includes(value),
    },
    isLoadLastDataLeaderboard: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    audienceData() {
      return this.data && this.data.audience
    },
    correctAnswers() {
      return this.audienceData && this.audienceData.correctAnswerCount
    },
    correctRate() {
      return this.audienceData && Math.round(this.audienceData.correctRate * 100)
    },
    currentPosition() {
      return this.data && this.data.indexFormat
    },
    audiencesCount() {
      return this.data && this.data.audiencesCount
    },
    ranking() {
      return `${this.currentPosition} / ${this.audiencesCount}`
    },
    isAnsweredAtLeastOne() {
      return this.data && this.data.index !== undefined
    },
    answerStatText() {
      const statText = this.type === 'team'
        ? 'final_team_answers_stat'
        : 'final_answers_stat'

      return this.$t(statText, {
        correctAnswers: this.correctAnswers,
        totalQuiz: this.currentQuiz,
        correctRate: this.correctRate,
      })
    },
    noQuizAnsweredText() {
      const textKey = this.type === 'team'
        ? 'team_no_quiz_answered'
        : 'personal_no_quiz_answered'

      return this.$t(textKey)
    },
    isShowCTA() {
      return this.isFinalLeaderboard && this.isAnsweredAtLeastOne
    },
  },
  methods: {
    viewMyAnswers() {
      this.$router.push({
        name: 'lookback',
        params: {
          id: this.$store.state.presentation.uniqueAccessCode,
        },
        query: {
          'lookback-tab': 'answers',
        },
      })

      util.ga4Track('Leaderboard > View Answer', {
        presentationId: this.presentationID,
        eventLabel: 'Lookback',
        eventCategory: 'Audience',
      })
    },
  },
}
</script>
<style lang="scss">
.final-title {
  p {
    margin-top: 0;
  }
}
</style>

<style lang="scss" scoped>
.leaderboard-head {
  margin-bottom: 24px;
}

.final-title {
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 12px;
}

.final-stat {
  margin-bottom: 8px;

  strong {
    font-weight: 700;
  }
}

.final-rank {
  margin-bottom: 8px;

  strong {
    font-weight: 700;
  }
}

.section-cta {
  text-align: center;
  display: flex;
  justify-content: center;

  .section-cta__button {
    min-width: 190px;
  }
}
</style>
